/**
 * Les mesures de `<TwoPaneTemplate>` que les pages lisent pour se mettre en page comme lui : pures,
 * elles se lisent sous Jest sans monter le gabarit.
 */

/**
 * Le seuil du côte à côte, le seul de l'espace élève : en deçà, un écran à la fois (les onglets
 * « Activité » / « Visio » du live, la copie sous l'énoncé, la conversation seule) ; à partir de lui,
 * les deux volets côte à côte. Le live, l'activité et la messagerie le lisent tous ici : l'activité
 * posée dans le live ne doit pas ouvrir son volet de copie là où le live est encore au téléphone.
 *
 * 1 100 px (Wajih, daily du 23/10 ; 1 000 avant) : un iPad Pro en portrait (1 024 px) prend la mise
 * en page du téléphone, où la visio et l'activité ont chacune tout l'écran ; un iPad en paysage
 * (1 133 px et plus) et un ordinateur gardent le côte à côte. 1 180 px a été jugé trop large : l'iPad
 * mini en paysage (1 133 px) serait passé au téléphone.
 */
export const TWO_PANE_FROM = 1100

/** La largeur du volet de la liste : une colonne de téléphone, un peu plus. */
export const TWO_PANE_LIST_WIDTH = 420
